import {PropertyApi} from "../property/PropertiesPanel";
import elementService, {ElementService} from "./service/ElementService";
import {PropertyCreateDto, PropertyDefinitionDto, PropertyDto} from "../../../../common/apis/property/PropertyApi";
import {ElementPropertyDefinition} from "../../../../common/ElementPropertyDefinitionContext";
import {AttributeDefinitionDto} from "../../../../common/apis/stereotype/AttributeDefinitionDto";
import stereotypeApiClient, {StereotypeApiClient} from "../../../../common/apis/stereotype/StereotypeApiClient";


export class ElementPropertyWrapperApi implements PropertyApi {

    private readonly apiClient: ElementService;
    private readonly stereotypeApiClient: StereotypeApiClient;

    constructor(readonly elementId: string,
            readonly stereotypeId: string | undefined,
            readonly propertyDefinitionContext: ElementPropertyDefinition) {
        this.apiClient = elementService;
        this.stereotypeApiClient = stereotypeApiClient;
    }

    getExistingPropertyDefinitions(): PropertyDefinitionDto[] {
        return this.propertyDefinitionContext.propertyDefinitions;
    }

    refreshExistingPropertyDefinitions(): void {
        this.propertyDefinitionContext.updatePropertyDefinitions();
    }

    findAllAttributeDefinitions(): Promise<AttributeDefinitionDto[]> {
        if (this.stereotypeId) {
            return this.stereotypeApiClient.findAllAttributes(this.stereotypeId);
        } else {
            return Promise.resolve([]);
        }
    }

    getProperties(): Promise<PropertyDto[]> {
        return this.apiClient.findAllProperties(this.elementId);
    }

    createProperty(name: string, type: string, value: string, propertyDefinitionId: string | undefined): Promise<PropertyDto> {
        const propertyCreate: PropertyCreateDto = {
            propDefIdentifier: propertyDefinitionId,
            name: name,
            type: type,
            value: value
        };
        return this.apiClient.createProperty(this.elementId, propertyCreate);
    }

    updateProperty(propertyDefinitionId: string, value: string): Promise<void> {
        return this.apiClient.updateProperty(this.elementId, propertyDefinitionId, value);
    }

    deleteProperty(propertyDefinitionId: string): Promise<void> {
        return this.apiClient.deleteProperty(this.elementId, propertyDefinitionId);
    }

}